import { render } from "./footer.vue?vue&type=template&id=52674bd0&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=52674bd0&scoped=true&lang=css"

import exportComponent from "D:\\project\\ncc-projectlib\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52674bd0"]])

export default __exports__